import React, { useState, useEffect, useRef } from 'react'
import { Button, FormControl, Form, Col, Row } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { FetchCreateCustomer, FetchUpdateCustomer, FetchOrderStates, FetchUpdateB2COrder, FetchOrderProcessingStates, FetchDeliveryAgents, FetchPaymentMethods } from '../../fetcher'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'

const DetailedOrder = ({ customerOrder, customerSalutation, handleOpenCustomer, handleCloseOrder, openAlert }) => {
    console.log("DetailedOrder2", customerOrder)

    const [isFAEX, setIsFAEX] = useState(false)

    const [allOrderStates, setAllOrderState] = useState({OrderStates: []})
    const [allOrderProcessingStates, setAllOrderProcessingState] = useState({ OrderProcessingStates: [] })
    const [allDeliveryAgents, setAllDeliveryAgents] = useState({ DeliveryAgents: []})
    const [allPaymentMethods, setAllPaymentMethods] = useState({ PaymentMethods: [] })

    const [orderState, setOrderState] = useState(EnumValueTranslations(customerOrder.article.OrderState))
    const [orderProcessingState, setOrderProcessingState] = useState(EnumValueTranslations(customerOrder.article.OrderProcessingState))
    const [paymentMethodForBillDue, setPaymentMethodForBillDue] = useState(EnumValueTranslations(customerOrder.article.PaymentMethodForBillDue))
    const [deliveryAgent, setDeliveryAgent] = useState(EnumValueTranslations(customerOrder.article.DeliveryAgent))

    const [designer, setDesigner] = useState(customerOrder.article.DesignerName)
    /*const [customer, setCustomer] = useState(customerOrderName)*/
    const [readyToBeSold, setReadyToBeSold] = useState(customerOrder.article.ReadyToBeSold)
    const [customerOrderName, setCustomerOrderName] = useState(customerSalutation)
    const [remarkAnDesigner, setRemarkAnDesigner] = useState(customerOrder.article.Remark)
    const [remarkAnFAEX, setRemarkAnFAEX] = useState(customerOrder.article.RemarkForFAEX)
    const [size, setSize] = useState(customerOrder.article.Size)
    const [amount, setAmount] = useState(customerOrder.article.Count)
    const [articleType, setArticleType] = useState(customerOrder.article.ArticleName)
    const [pointOfSale, setPointOfSale] = useState(customerOrder.order.PointOfOrdering)
    const [date, setDate] = useState(customerOrder.order.Date)

    const [dateOrderedDesigner, setDateOrderedDesigner] = useState(customerOrder.article.OrderedFromLabel)
    const [dateArrived, setDateArrived] = useState(customerOrder.article.ReceivedFromLabel)
    const [dateShipped, setDateShipped] = useState(customerOrder.article.ShippedToCustomer)
    const [dateShippedToBoutique, setDateShippedToBoutique] = useState(customerOrder.article.ShippedToBoutique)
    const [dateReturned, setDateReturned] = useState(customerOrder.article.ReturnedByCustomer)
    const [datePickedUp, setDatePickedUp] = useState(customerOrder.article.PickedUpByCustomer)

    const [dateRemainingPayment, setDateRemainingPayment] = useState(customerOrder.article.RemainingPaymentDate)
    const [dateRefundPayment, setDateRefundPayment] = useState(customerOrder.article.RefundPaymentDate)
    const [billnumber, setBillnumber] = useState(customerOrder.article.BillNumber)
    const [trackingLink, setTrackingLink] = useState(customerOrder.article.TrackingLink)


    const [priceUnit, setPriceUnit] = useState(parseFloat(customerOrder.article.PriceUnit).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
    const [priceTotal, setPriceTotal] = useState(parseFloat(customerOrder.article.Count * parseFloat(customerOrder.article.PriceAtTimeOfSale)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
    const [prepayment, setPrepayment] = useState(parseFloat(customerOrder.article.Count * parseFloat(customerOrder.article.PrepaymentAtTimeOfSale)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
    const [priceAtTimeOfSale, setPriceAtTimeOfSale] = useState(parseFloat((-1) * (parseFloat(customerOrder.article.PriceUnit) - parseFloat(customerOrder.article.PriceAtTimeOfSale))).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
    const [toBePayed, setToBePayed] = useState(parseFloat(customerOrder.article.BillToPay).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))

    const [notizenAnDesignerHeader, setNotizenAnDesignerHeader] = useState("")
    const [notizenAnFAEXHeader, setNotizenAnFAEXHeader] = useState("")

    const handleSubmit = (e) => {
        e.preventDefault()

        let orderUpdate = {
            OrderState: orderState,
            OrderProcessingState: orderProcessingState,
            DeliveryAgent: deliveryAgent,
            Remark: remarkAnDesigner,
            DateOfSale: date,
            OrderedFromLabel: dateOrderedDesigner,
            ReceivedFromLabel: dateArrived,
            ShippedToCustomer: dateShipped,
            ShippedToBoutique: dateShippedToBoutique,
            ReturnedByCustomer: dateReturned,
            PickedUpByCustomer: datePickedUp,
            RemainingPaymentDate: dateRemainingPayment,
            PaymentMethodForBillDue: paymentMethodForBillDue,
            RefundPaymentDate: dateRefundPayment,
            Billnumber: billnumber,
            TrackingLink: trackingLink,

            RemarkSysId: customerOrder.article.RemarkSysId,
            ArticleDataSysId: customerOrder.article.ArticleDataSysId,
            AbstractTransactionSysId: customerOrder.order.TransactionSysId,
        }

        FetchUpdateB2COrder(orderUpdate, handleCloseOrder, openAlert, null)
    }

    useEffect(() => {
        FetchOrderStates(setAllOrderState, openAlert)
        FetchOrderProcessingStates(setAllOrderProcessingState, openAlert)
        FetchDeliveryAgents(setAllDeliveryAgents, openAlert)
        FetchPaymentMethods(setAllPaymentMethods, openAlert)
    }, [])

    useEffect(() => {
        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setIsFAEX(true)
        }
    }, [])

    const handleSetOrderState = (e) => {
        e.preventDefault()
        console.log("handleSetOrderState2", e, e.target, e.target.key)
        setOrderState(allOrderStates.OrderStates.find(x => EnumValueTranslations(x.OrderState) === e.target.value))
    } 

    const handleSetOrderProcessingState = (e) => {
        e.preventDefault()
        setOrderProcessingState(allOrderProcessingStates.OrderProcessingStates.find(x => EnumValueTranslations(x.OrderProcessingState) === e.target.value))
    }

    const handleSetPaymentMethod = (e) => {
        e.preventDefault()
        setPaymentMethodForBillDue(allPaymentMethods.PaymentMethods.find(x => EnumValueTranslations(x.PaymentMethod) === e.target.value))
    }

    const handleSetDeliveryAgent = (e) => {
        e.preventDefault()
        setDeliveryAgent(allDeliveryAgents.DeliveryAgents.find(x => EnumValueTranslations(x.DeliveryAgent) === e.target.value))
    } 

    useEffect(() => {
        setNotizenAnDesignerHeader("Notizen:")
    }, designer)

    useEffect(() => {
        setNotizenAnFAEXHeader("Notizen" + (designer.length > 0 ? " von " + designer + ":" : "von Designer:"))
    }, pointOfSale)

    const openTrankingLink = (e) => {
        e.preventDefault()
        window.open(trackingLink, '_blank', 'noreferrer')
    }

    return (
        <div lang="de" className="detailedOrder">
            <Form noValidate onSubmit={handleSubmit} id='update-order-form'>
                <Form.Group controlId="article-select">
                    {/*<Form.Label className="controlTitleHeader">Bestelldaten</Form.Label>*/}

                    <Row className="mb-3">
                        <Form.Group as={Col} md={3} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Label:</Form.Label>
                            <Form.Control as="input" disabled value={designer}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={3} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Bestelldatum:</Form.Label>
                            <DateRangePicker disabled={!isFAEX}
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDate(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDate(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl disabled={!isFAEX} as="input" className="form-control" defaultValue={date} autocomplete="off" />
                            </DateRangePicker>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">Bestellstatus:</Form.Label>
                            <Form.Control as="select" value={EnumValueTranslations(orderState.OrderState)} onChange={(e) => handleSetOrderState(e)}>
                                <option disabled key="0">{"NA"}</option>
                                {allOrderStates.OrderStates.filter(x => x.OrderStateEnum !== 0 && x.OrderStateEnum !== 5).map(x =>
                                    <option key={x.OrderStateEnum}>{EnumValueTranslations(x.OrderState)}</option>
                                )}
                                <option disabled>-------------------------------</option>
                                {allOrderStates.OrderStates.find(x => x.OrderStateEnum == 5) != undefined ?
                                    <option key="5" disabled={!customerOrder.article.ReadyToBeSold}>{EnumValueTranslations(allOrderStates.OrderStates.find(x => x.OrderStateEnum == 5).OrderState)}</option> : <></>}
                            </Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Artikeltyp:</Form.Label>
                            <Form.Control as="input" disabled value={articleType}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">Bearbeitungsstatus:</Form.Label>
                            <Form.Control as="select" value={EnumValueTranslations(orderProcessingState.OrderProcessingState)} onChange={(e) => handleSetOrderProcessingState(e)}>
                                {allOrderProcessingStates.OrderProcessingStates.map(x =>
                                    <option>{EnumValueTranslations(x.OrderProcessingState)}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Größe:</Form.Label>
                            <Form.Control as="input" disabled value={size}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Einzelpreis:</Form.Label>
                            <Form.Control className="numberColumn" as="input" disabled value={priceUnit}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Preisänderung:</Form.Label>
                            <Form.Control className="numberColumn" as="input" disabled value={priceAtTimeOfSale > 0 ? "+" : "" + priceAtTimeOfSale}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03" onClick={handleOpenCustomer}>
                            <Form.Label className="controlTitle">Kunde: &#9998;</Form.Label>
                            <Form.Control as="input" disabled value={customerOrderName}></Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Anzahl:</Form.Label>
                            <Form.Control className="numberColumn" as="input" disabled value={amount}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Summe:</Form.Label>
                            <Form.Control className="numberColumn" as="input" disabled value={priceTotal}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Anzahlung:</Form.Label>
                            <Form.Control className="numberColumn" as="input" disabled value={prepayment}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">Standort:</Form.Label>
                            <Form.Control as="input" disabled value={pointOfSale}></Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={3} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">Zahlungsart (Anzahlung):</Form.Label>
                            <Form.Control as="input" disabled value={EnumValueTranslations(customerOrder.order.Payment)}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Noch offen:</Form.Label>
                            <Form.Control className="numberColumn" as="input" disabled value={toBePayed}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01" >
                            <Form.Label className="controlTitle">Restzahlung Datum:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateRemainingPayment(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateRemainingPayment(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateRemainingPayment} autocomplete="off" />
                            </DateRangePicker>
                        </Form.Group>
                        <Form.Group as={Col} md={3} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">Zahlungsart (Restzahlung):</Form.Label>
                            <Form.Control as="select" value={EnumValueTranslations(paymentMethodForBillDue.PaymentMethod)} onChange={(e) => handleSetPaymentMethod(e)}>
                                {allPaymentMethods.PaymentMethods.map(x =>
                                    <option>{EnumValueTranslations(x.PaymentMethod)}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} md={2} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">Versand an Kundin durch:</Form.Label>
                            <Form.Control disabled={!isFAEX} as="select" value={EnumValueTranslations(deliveryAgent.DeliveryAgent)} onChange={(e) => handleSetDeliveryAgent(e)}>
                                {allDeliveryAgents.DeliveryAgents.map(x =>
                                    <option>{EnumValueTranslations(x.DeliveryAgent)}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={3} controlId="customGroup01-01" >
                            <Form.Label className="controlTitle">Erstattung Datum:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateRefundPayment(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateRefundPayment(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateRefundPayment} autocomplete="off" />
                            </DateRangePicker>
                        </Form.Group>

                        <Form.Group as={Col} md={4} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">Rechnungsnummer:</Form.Label>
                            <Form.Control id="rechnungsnummer" type="textarea" label="Rechnungsnummer" disabled={!isFAEX}
                                value={billnumber} onChange={(e) => setBillnumber(e.target.value)} />
                        </Form.Group>
                        <Form.Group as={Col} md={3} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">Trackinglink:</Form.Label>
                            <Form.Control id="trackinglinkText" type="textarea" label="trackinglinkText" disabled={!isFAEX}
                                value={trackingLink} onChange={(e) => setTrackingLink(e.target.value)} />
                        </Form.Group>
                        <Form.Group as={Col} md={1} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Öffnen:</Form.Label>
                            {trackingLink !== "" && trackingLink !== undefined && trackingLink !== null ?
                                <Button disabled={trackingLink == ""} role="link" variant="light">
                                    <a href={trackingLink} target="_blank" rel="noreferrer" hidden={trackingLink == "" || trackingLink == undefined || trackingLink == null}>
                                        Link
                                    </a>
                                </Button> : <Form.Label disabled>Nicht verfügbar</Form.Label>}
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={4} controlId="customGroup01-01" > 
                            <Form.Label className="controlTitle">Ware bei Designer bestellt:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateOrderedDesigner(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateOrderedDesigner(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateOrderedDesigner} autocomplete="off" disabled={!isFAEX} />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">Ware angekommen:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateArrived(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateArrived(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateArrived} autocomplete="off" />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">Ware an Kunden verschickt:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateShipped(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateShipped(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateShipped} autocomplete="off" />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">Ware zur Boutique verschickt:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateShippedToBoutique(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateShippedToBoutique(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateShippedToBoutique} autocomplete="off" disabled={!isFAEX} />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">Ware vom Kunden zurückgekommen:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                    drops: "up",
                                }}
                                onCallback={(manualDate) => setDateReturned(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateReturned(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={dateReturned} autocomplete="off" />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">Ware vom Kunden abgeholt:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                    drops: "up",
                                }}
                                onCallback={(manualDate) => setDatePickedUp(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDatePickedUp(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" className="form-control" defaultValue={datePickedUp} autocomplete="off" />
                            </DateRangePicker>
                        </Form.Group>

                        <Form.Group as={Col} md={8} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{notizenAnDesignerHeader}</Form.Label>
                            <Form.Control className="order-textarea" as="textarea" value={remarkAnDesigner} onChange={(e) => setRemarkAnDesigner(e.target.value)}></Form.Control>
                            <Form.Label className="controlTitle">{notizenAnFAEXHeader}</Form.Label>
                            <Form.Control className="order-textarea" as="textarea" disabled value={remarkAnFAEX}></Form.Control>
                        </Form.Group>
                    </Row>
                </Form.Group>
            </Form>
        </div>
    );
}

export { DetailedOrder }